<template>
    <div class="notice">
        <div class="list">
            <div class="item pointer" v-for="(item,index) in list" :key="index" @click="gotNoticeDeatails(item)">
                <div>{{item.title}}</div>
                <div>{{item.content}}</div>
                <div>
                    <div class="btn blue bg_02" v-if="item.announcementFiles!=''">点击查看附件</div>
                    <div class="time">{{item.createDate}}</div>
                </div>
            </div>
        </div>
        <div class="page">
            <el-pagination @current-change="handleCurrentChange" background :current-page="pageNum" :page-size="12"
                layout="prev, pager, next" :total="count">
            </el-pagination>
            <input type="text" name="" id="" v-model="num" />
            <el-button size="mini" style="margin-left: 16px;" @click="inputCurrentChange">跳转</el-button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Notice",
        data() {
            return {
                count: 0,
                list: [],
                pageNum: 1,
                num: null,
            }
        },
        created() {
            this.getList();
        },
        methods: {
            gotNoticeDeatails(item) {
                this.$router.push({
                    path: '/notice_details',
                    query: item
                })
            },
            inputCurrentChange() {
                if (!this.num) {
                    return;
                }
                this.pageNum = this.num / 1;
                this.getList();
            },
            handleCurrentChange(pageNum) {
                this.pageNum = pageNum;
                this.getList();
            },
            getList() {
                this.request.post(this.$store.state.ryHttpUrl + "announcement/ryAnnouncementList", {
                    page: this.pageNum,
                    limit: 10,
                    businessNo: this.$store.state.orgCode
                }).then(res => {
                    if (res.code == 200) {
                        this.list = res.data;
                        this.count = res.count;
                    }
                });
            }
        }
    };
</script>

<style scoped>
    .notice {
        background: #FFFFFF;
    }

    .list {
        width: 1200px;
        margin: 0 auto;
        text-align: left;
    }

    .list>div {
        border-bottom: 1px solid #CCCCCC;
    }

    .list>div:last-child {
        border: none;
    }

    .item {
        padding: 16px 0;
    }

    .item>div:nth-child(1) {
        font-size: 20px;
        font-weight: bold;
        color: #333333;
    }

    .item>div:nth-child(2) {
        font-size: 14px;
        color: #666666;
        margin-top: 12px;
        line-height: 18px;
    }

    .item>div:nth-child(3) {
        display: flex;
        line-height: 28px;
        margin-top: 12px;
    }

    .item>div:nth-child(3)>.btn {
        width: 136px;
        height: 28px;
        border-radius: 5px;
        text-align: center;
        font-size: 12px;
        margin-right: 36px;
    }

    .item>div:nth-child(3)>.time {
        font-size: 14px;
        color: #999999;
    }
</style>



// WEBPACK FOOTER //
// src/view/notice/notice.vue